module.exports = __webpack_public_path__ + "media/3-12.dbf68a6c.wav";